/* MDL accessibility overlay — proactive fixes applied at runtime.
   Scope: never changes layout or behavior; only fills missing a11y semantics. */
(function () {
  "use strict";

  var MAIN_CONTENT = "MainContent";

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function visibleLabel(el) {
    return (el && el.getAttribute && el.getAttribute("aria-label")) || "";
  }

  function textOf(el) {
    return ((el && el.textContent) || "").replace(/\s+/g, " ").trim();
  }

  /* 1. Skip link — first focusable element on the page */
  function addSkipLink() {
    if (document.querySelector(".mdl-skip-link")) return;
    var main = document.getElementById(MAIN_CONTENT);
    if (!main) return;
    var link = document.createElement("a");
    link.className = "mdl-skip-link";
    link.href = "#" + MAIN_CONTENT;
    link.textContent = "Aller au contenu";
    document.body.insertBefore(link, document.body.firstChild);
  }

  /* 2. Icon-only close buttons inside panel headings */
  function namePanelCloseButtons() {
    document.querySelectorAll("ui-panel").forEach(function (panel) {
      var headings = panel.querySelectorAll(":scope > slot-heading, :scope [slot='heading'], :scope slot-heading");
      headings.forEach(function (heading) {
        heading.querySelectorAll("button").forEach(function (btn) {
          var hasLabel = btn.getAttribute("aria-label") || "";
          var hasText = textOf(btn);
          if (!hasLabel && !hasText) {
            btn.setAttribute("aria-label", "Fermer");
          }
        });
      });
    });
  }

  /* 3. Fix aria-labelledby referencing missing ids */
  function fixAriaLabelledBy() {
    document.querySelectorAll("[aria-labelledby]").forEach(function (el) {
      var refs = el.getAttribute("aria-labelledby") || "";
      refs.split(/\s+/).filter(Boolean).forEach(function (ref) {
        if (document.getElementById(ref)) return;
        var candidate = null;
        var scope = el.closest("ui-panel, [role='dialog'], [role='dialog'] > *") || document;
        var nodes = scope.querySelectorAll ? scope.querySelectorAll("h1,h2,h3,h4,h5,h6,div,p,span,strong") : [];
        for (var i = 0; i < nodes.length; i++) {
          if ((textOf(nodes[i]) || "").toLowerCase() === ref.toLowerCase()) {
            candidate = nodes[i];
            break;
          }
        }
        if (candidate && candidate.id === "") {
          candidate.id = "mdl-labelled-" + ref.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        }
        if (candidate && candidate.id) {
          el.setAttribute("aria-labelledby", candidate.id);
        } else {
          el.removeAttribute("aria-labelledby");
        }
      });
    });
  }

  /* 4. Fix aria-controls referencing labels instead of ids */
  function fixAriaControls() {
    document.querySelectorAll("[aria-controls]").forEach(function (el) {
      var ref = (el.getAttribute("aria-controls") || "").trim();
      if (!ref || document.getElementById(ref)) return;
      var scope = closest(el, "ui-accordion, [class*='accordion'], li, details, nav") || document;
      var nodes = scope.querySelectorAll ? scope.querySelectorAll("h2,h3,h4,h5,h6,strong,p,span,div") : [];
      var candidate = null;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n === el || el.contains(n)) continue;
        if ((textOf(n) || "").toLowerCase() === ref.toLowerCase()) {
          candidate = n;
          break;
        }
      }
      if (candidate) {
        if (!candidate.id) {
          candidate.id = "mdl-target-" + ref.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
        }
        el.setAttribute("aria-controls", candidate.id);
      } else {
        el.removeAttribute("aria-controls");
      }
    });
  }

  /* 5. Unnamed predictive search input */
  function labelSearchInputs() {
    document.querySelectorAll("input[predictive-search], input[type='search']").forEach(function (input) {
      if (!input.getAttribute("aria-label") && !input.getAttribute("id")) {
        input.setAttribute("aria-label", "Rechercher");
      }
    });
  }

  /* 6. Invisible mobile placeholder <div class="needsclick"> focus stops */
  function neutralizeInvisibleFocusStops() {
    document.querySelectorAll("div.needsclick").forEach(function (el) {
      if (el.closest && el.closest("#axeptio_overlay")) return;
      var rect = el.getBoundingClientRect();
      if (rect.height < 8) {
        el.setAttribute("inert", "");
      }
    });
  }

  /* 6b. Demote island headings that should not be h1 (e.g. recently-viewed-products) */
  function demoteExtraH1() {
    document.querySelectorAll("recently-viewed-products h1, .recently-viewed-products h1").forEach(function (h) {
      var plain = h.cloneNode(false);
      plain.textContent = h.textContent;
      h.replaceWith(plain);
      if (plain.tagName === "H1") {
        var p = document.createElement("h2");
        p.textContent = plain.textContent;
        plain.replaceWith(p);
      }
    });
  }

  /* 7. Empty headings (e.g. recommendations block with empty title) */
  function removeEmptyHeadings() {
    document.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach(function (heading) {
      if (!textOf(heading)) heading.remove();
    });
  }

  /* 7b. Fix invalid nesting produced by the page builder:
     <h2><p>X</p></h2> / <h2><h2>X</h2></h2> / <p><p>X</p></p> */
  function unwrapNestedBlocks() {
    document.querySelectorAll("h1,h2,h3,h4,h5,h6,p").forEach(function (el) {
      if (el.childNodes.length !== 1) return;
      var child = el.firstChild;
      if (child.nodeType !== 1) return;
      var tag = child.tagName;
      if (!/^(H[1-6]|P)$/.test(tag)) return;
      if (el.tagName === "P") {
        el.replaceWith(child);
      } else {
        el.innerHTML = child.innerHTML;
      }
    });
  }

  /* 8. Alma badge error message injection (Merchant ID not set) */
  function purgeAlmaError(root) {
    var nodes = (root.querySelectorAll ? root.querySelectorAll("h2, h1, div, p, span") : []);
    nodes.forEach(function (el) {
      var text = el.textContent || "";
      if (/can't display alma badge/i.test(text)) {
        var wrapper = closest(el, "[id*='alma' i], [class*='alma' i], [data-alma]");
        if (wrapper) {
          wrapper.style.display = "none";
        } else {
          el.style.display = "none";
        }
      }
    });
  }

  /* 9. aria-expanded sync for drawer triggers */
  function syncTriggerExpanded() {
    document.querySelectorAll("layer-action[layer-id], [aria-haspopup][aria-controls]").forEach(function (trigger) {
      var panelId = trigger.getAttribute("layer-id") || trigger.getAttribute("aria-controls");
      if (!panelId) return;
      var panel = document.getElementById(panelId);
      if (!panel) return;
      var isOpen = panel.hasAttribute("open") || panel.getAttribute("data-open") === "true" || panel.getAttribute("aria-hidden") === "false";
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  /* 10. Layout <ul> containing non-<li> children (e.g. nested ui-panel in menus):
     fall back to presentation semantics so the a11y tree stays valid. */
  function fixListSemantics() {
    document.querySelectorAll("ul").forEach(function (ul) {
      if (ul.getAttribute("role")) return;
      var invalid = Array.prototype.some.call(ul.children, function (child) {
        return child.tagName !== "LI" && child.tagName !== "SCRIPT" && child.tagName !== "TEMPLATE";
      });
      if (invalid) ul.setAttribute("role", "presentation");
    });
  }

  /* 11. Targeted French typography fixes (visible text, no data change) */
  var TYPO_FIXES = [
    ["Jusqu'a 12x", "Jusqu'à 12x"]
  ];

  function fixCommonTypos(scope) {
    var nodes = (scope && scope.querySelectorAll) ? scope.querySelectorAll("*") : [];
    nodes.forEach(function (el) {
      if (el.childNodes.length !== 1) return;
      var node = el.firstChild;
      if (node.nodeType !== 3) return;
      var text = node.nodeValue;
      var changed = text;
      TYPO_FIXES.forEach(function (pair) {
        changed = changed.split(pair[0]).join(pair[1]);
      });
      if (changed !== text) node.nodeValue = changed;
    });
  }

  function bindAxeptioCookieLink() {
    if (window.__mdlAxeptioCookieLinkInit) return;
    window.__mdlAxeptioCookieLinkInit = true;
    document.addEventListener("click", function (event) {
      var link = closest(event.target, "a");
      if (!link) return;
      var href = (link.getAttribute("href") || "").trim().toLowerCase();
      var label = textOf(link).toLowerCase();
      var isAxeptioLink = href === "#javascript:openaxeptiocookies()" || href === "javascript:openaxeptiocookies()" || label === "paramètres cookies";
      if (!isAxeptioLink || typeof window.openAxeptioCookies !== "function") return;
      event.preventDefault();
      event.stopPropagation();
      window.openAxeptioCookies();
    }, true);
  }

  function run() {
    addSkipLink();
    namePanelCloseButtons();
    fixAriaLabelledBy();
    fixAriaControls();
    labelSearchInputs();
    neutralizeInvisibleFocusStops();
    demoteExtraH1();
    removeEmptyHeadings();
    unwrapNestedBlocks();
    purgeAlmaError(document);
    syncTriggerExpanded();
    fixListSemantics();
    fixCommonTypos(document);
    bindAxeptioCookieLink();
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    run();
    var observer = new MutationObserver(function (mutations) {
      var dirty = false;
      mutations.forEach(function (m) {
        if (m.type === "childList" && m.addedNodes.length) dirty = true;
        if (m.type === "attributes" && ["open", "data-open", "aria-hidden"].indexOf(m.attributeName) !== -1) dirty = true;
      });
      if (!dirty) return;
      addSkipLink();
      namePanelCloseButtons();
      fixAriaLabelledBy();
      fixAriaControls();
      labelSearchInputs();
      neutralizeInvisibleFocusStops();
      demoteExtraH1();
      removeEmptyHeadings();
      unwrapNestedBlocks();
      purgeAlmaError(document);
      syncTriggerExpanded();
      fixListSemantics();
      fixCommonTypos(document);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
  });
})();
